
import { config } from "../config";
declare const window: any;

const getProductKeys = (cart) => {
    let productsOnPage: any = {}, item;
    for(const mainItemKey of Object.keys(cart.lineItems)){
        item = cart.lineItems[mainItemKey];
        item = item[0]['data']
        const productKey = item['productKey']
        productsOnPage[productKey] = `/${productKey.toLowerCase()}/`
    }
    const str = Object.values(productsOnPage).join(",");
    return str;
}


const getWebCode = (cart) => {
    let productsOnPage: string[] = [], item;
    for(const mainItemKey of Object.keys(cart.lineItems)){
        item = cart.lineItems[mainItemKey];
        item = item[0]['data']
        const webCode = item['webCode']
        productsOnPage.unshift(webCode);
    }
    const str = productsOnPage.join(",");
    return str;
}

const getWebcodeOrderDetails = (order) => {
    let productsOnPage: any = {}, item;
    for (const mainItemKey of Object.keys(order.lineItems)) {
        item = order?.lineItems[mainItemKey];
        const webCode = item['webCode']
        if (webCode) {
            productsOnPage[webCode] = `/${webCode.toLowerCase()}/`
        }
    }
    const str = Object.values(productsOnPage).join(",");
    return str;
}

interface Cart {
    lineItems: Array<{ productKey: string }>;
}

const getWebcodeOrderHistory = (orderHist: Cart[]) => {
    const productsOnPage: any = {};
    const itemsToProcess = orderHist?.length > 5 ? orderHist.slice(0, 5) : orderHist;
    for (const items of Object.values(itemsToProcess)) {
        for (const mainItemKey of Object.keys(items.lineItems)) {
            const item = items?.lineItems[mainItemKey];
            const webCode = item?.webCode;
            if (webCode) {
                productsOnPage[webCode] = `/${webCode.toLowerCase()}/`;
            }
        }
    }
    const str = Object.values(productsOnPage).join(",");
    return str;
};

export const purchaseCTEventTrigger = (order :any) => {
    const products :any =[];
    for(const lineItem of Object.values(order.lineItems) as any){
        products.push(lineItem[0].data)
    }
    if(products && products.length>0){
        const payloadItemsArray: any = [];
        const addedProductKeys: any = [];
        products.forEach((product) => {
            if (window.np.CTRecommendations && window.np.CT_UTILS.getRecommendationId && window.np.CT_UTILS.getRecommendationId(product.productKey)){
                if (!addedProductKeys.includes(product.productKey)){
                    addedProductKeys.push(product.productKey);
                    let itemPayloadData = {
                        recommendationId: window.np.CT_UTILS.getRecommendationId(product.productKey),
                        item_id: product.webCode,
                        item_price: product.unitPrice,
                        quantity: product.quantity
                    }
                    payloadItemsArray.push(itemPayloadData);
                }
            }
        })
        if(window.np.CTRecommendations?.updateMetric && payloadItemsArray?.length > 0){
            window.np.CTRecommendations.updateMetric({
                action: 'purchased',
                items:  payloadItemsArray          
            });
        }
    } 
}  

const getCTRecommendationsPayload = (page, order?, orderHistory?) => {
    const payload = {
        lob: config("regionCode"),
        components: page,
        locale: config("locale"),
    };

    if (order && Object.keys(order).length > 0) {
        payload["productsOnPage"] = getWebcodeOrderDetails(order);
    } else if (orderHistory && Object.keys(orderHistory).length > 0) {
        payload["productsOnPage"] = getWebcodeOrderHistory(orderHistory);
    }

    return payload;
};


const getCTRecommendationsCallback = (colSize, isOrderConfirmationPage, isMyacnt, isLoggedIn = "true") => {
    return function (recommendations, error) {
        const isReactApp = true;
        if (error || recommendations.status === "Failed" || !recommendations.placements.length) return;
        if (isOrderConfirmationPage) {
            window.np.CT_UTILS.placements.ORDER_CONFIRMATION(recommendations.placements, isReactApp);
        } else if (isMyacnt) {
            const isLog = isLoggedIn === 'true';
            window.np.CT_UTILS.placements.MY_ACCOUNT(recommendations.placements, isReactApp, isLog);
        } else {
            window.np.CT_UTILS.placements.SHOPPING_BAG(recommendations.placements, colSize, isReactApp);
        }
    };
}

const getViewSimilarCallback = (colSize,containerId) => {
    const vscontainerId = `#${containerId}`
    return function (recommendations, error) {
        if (error || recommendations.status === "Failed" || !recommendations.placements.length) return;
        if(colSize){
            window.np.CT_UTILS.getContainerId(vscontainerId,recommendations.placements,colSize,true);
        }
    };
}

const displayCTRecommendations = (dispStr:string) => {
    const ctRecommendations: any = document.querySelector('#shopping-bag-ct-recs');
        if (ctRecommendations) {
            ctRecommendations.style.display = dispStr;
        }
}
const displayViewSimilar = (dispStr:string) => {
    const ctRecommendations: any = document.querySelector('#view-similar-ct-recs');
        if (ctRecommendations) {
            ctRecommendations.style.display = dispStr;
        }
}

export const getCTRecommendations = (cart, page, colSize, isOrderConfirmationPage = false, isMyacnt = false) =>{
    if (window.np && window.np.CTRecommendations && window.np.CT_UTILS && window.np.CT_UTILS.isRealUser()) {
        displayCTRecommendations('block');
        const payload = {
            lob: config('regionCode'),
            components: page,
            locale: config('locale')
        };
        if(cart?.mainItemCount > 0) {
            payload['productsOnPage'] = getWebCode(cart);
        }else{
            colSize = 3;
        }

        if(page === 'Cart Page'){
            payload['placementId'] = window.Config?.CART_PAGE_CT_RECS_PLACEMENTID;
        }

            
        const callback = getCTRecommendationsCallback(colSize, isOrderConfirmationPage, isMyacnt);
        window.np.CTRecommendations.getRecommendations(payload, callback);
    } else {
        displayCTRecommendations('none');
    }
}

const getLastMerchCategory = (merchCatKey) => {
    if (!merchCatKey || typeof merchCatKey !== 'string') {
        return 'Dummy'; 
    }
    
    const trimmedKey = merchCatKey.trim();
    if (!trimmedKey) return 'Dummy'; 

    const categories = trimmedKey.split('_').filter(Boolean); 
    return categories.length ? categories[categories.length - 1] : 'Dummy';
};

const getMerchCategoryKey = (lineItemId) => {
    if (!lineItemId) return 'Dummy'; 

    const excludedMerchCategories = ["Search", "Not-Applicable", "Recommendation"];

    try {
        const PdiObj = window.pdi?.localStorage?.get?.();
        if (!PdiObj || typeof PdiObj !== 'object') return 'Dummy'; 

        const productData = PdiObj[lineItemId];
        if (!productData || typeof productData !== 'object') return 'Dummy'; 

        const { merchCatKey } = productData;
        if (!merchCatKey) return 'Dummy'; 

        if (excludedMerchCategories.includes(merchCatKey)) return merchCatKey; 

        return getLastMerchCategory(merchCatKey);
    } catch (error) {
        console.error('Error fetching merch category key:', error);
        return 'Dummy'; 
    }
};

export const getViewSimilar = (webCode, page, colSize, containerId,lineItemId) =>{
    const categoryName = getMerchCategoryKey(lineItemId);
    if (window.np && window.np.CTRecommendations && window.np.CT_UTILS && window.np.CT_UTILS.isRealUser()) {
        displayViewSimilar('block');
        const payload = {
            lob: config('regionCode'),
            components: page,
            locale: config('locale'),
            placementId : window.Config?.CART_PAGE_VIEW_SIMILAR_PLACEMENTID,
			isViewSimilarPlacement : true,
        };

        payload['filterByCategories'] = categoryName || 'Dummy';
    
        payload['productsOnPage'] = webCode;
            
        const callback = getViewSimilarCallback(colSize,containerId);
        window.np.CTRecommendations.getRecommendations(payload, callback);
    } else {
        displayViewSimilar('none');
    }
}

export const getCTRecommendationsOrderDetails = (order, page, colSize, isOrderConfirmationPage = false, isMyacnt = false, isLoggedIn) =>{
    if (window.np && window.np.CTRecommendations && window.np.CT_UTILS && window.np.CT_UTILS.isRealUser()) {
        displayCTRecommendations('block');

        const payload = getCTRecommendationsPayload(page, order);
            
        const callback = getCTRecommendationsCallback(colSize, isOrderConfirmationPage, isMyacnt, isLoggedIn);
        window.np.CTRecommendations.getRecommendations(payload, callback);
    } else {
        displayCTRecommendations('none');
    }
}

export const getCTRecommendationsOrderHistory = (order, page, colSize, isOrderConfirmationPage = false, isMyacnt = false) =>{
    if (window.np && window.np.CTRecommendations && window.np.CT_UTILS && window.np.CT_UTILS.isRealUser()) {
        displayCTRecommendations('block');

        const payload = getCTRecommendationsPayload(page, undefined, order);
            
        const callback = getCTRecommendationsCallback(colSize, isOrderConfirmationPage, isMyacnt);
        window.np.CTRecommendations.getRecommendations(payload, callback);
    } else {
        displayCTRecommendations('none');
    }
}
